import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    label: {
        fontSize: "14px !important",
        fontWeight: 600,
        fontFamily: "Open Sans",
    },
    editableBox: {
        display: "flex",
        flexDirection: "column",
        width: "100%",
    },
    editableBoxButtons: {
        marginTop: `${theme.spacing(2)} !important`,
        marginBottom: `${theme.spacing(4)} !important`,
        display: "flex",
        justifyContent: "flex-end",
        gap: theme.spacing(2),
    },
    boxButtons: {
        display: "flex",
        gap: theme.spacing(1),
    },
    plainText: {
        fontSize: "14px",
        fontWeight: 400,
        fontFamily: "Open Sans",
        marginBottom: `${theme.spacing(4)} !important`,
    },
    tittle: {
        display: "flex",
        alignItems: "center",
        marginBottom: `${theme.spacing(2)} !important`,
        justifyContent: "space-between",
    },
    questionsAndAnswersWrapper: {
        display: "flex",
        flexDirection: "column",
        width: "100%",
    },
    questionsAndAnswersItemWrapper: {
        display: "flex",
        flexDirection: "column",
    },
    aWrapper: {
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(2),
        marginBottom: `${theme.spacing(4)} !important`,
    },
    qWrapper: {
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        marginTop: `${theme.spacing(4)} !important`,
    },
    aIcon: {
        fontSize: "14px",
        fontWeight: 700,
        fontFamily: "Open Sans",
        backgroundColor: theme.palette.info.main,
        height: theme.spacing(6),
        width: theme.spacing(6),
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        borderRadius: "100%",
        color: theme.palette.primary.main,
        flexShrink: 0,
    },
    qIcon: {
        fontSize: "14px",
        fontWeight: 700,
        fontFamily: "Open Sans",
        backgroundColor: theme.palette.border.tabs,
        height: theme.spacing(6),
        width: theme.spacing(6),
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        borderRadius: "100%",
        color: theme.palette.primary.main,
        flexShrink: 0,
    },
    qLeftContent: {
        display: "flex",
        gap: theme.spacing(2),
        width: "100%",
    },
    qText: {
        fontSize: "14px",
        fontWeight: 400,
        fontFamily: "Open Sans",
        fontStyle: "italic",
    },
    aText: {
        fontSize: "14px",
        fontWeight: 600,
        fontFamily: "Open Sans",
    },
    addAnotherWhyQAWrapper: {
        marginBottom: `${theme.spacing(4)} !important`,
        marginTop: `${theme.spacing(4)} !important`,
    },
    rootCauseConclusionWrapper: {
        marginBottom: `${theme.spacing(4)} !important`,
        marginTop: `${theme.spacing(4)} !important`,
    },
}));
